import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useLoading } from "@ti/hooks";
import { SwitchLocale, getSearchParams } from "../../index";
import useStyles from "./style";
import LoginPanel from "./components/LoginPanel";
import { LoginType } from "./types";
import SelectCompany from "./components/SelectCompany";
import LoginWrapper from "./components/LoginWrapper";
const TiLogin = (props) => {
  const searchParams = getSearchParams();
  const { code: feishuCode } = searchParams;
  const {
    appName,
    backgroundImage,
    loginRequest,
    companyListRequest,
    loginTypes = [LoginType.Account],
    showForgotPassword = true,
    appVersion,
    renderExtraCompanyInfo,
    showSwitchLocale,
    onLogin,
    feishuParams,
    companyFieldNames,
    verificationRequest,
    onForgotPassword
  } = props;
  const { styles } = useStyles();
  const [companyList, setCompanyList] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const { loading, runTask } = useLoading();
  useEffect(() => {
    if (feishuCode) {
      handleLogin({
        code: feishuCode,
        loginType: LoginType.Feishu
      });
    }
  }, [feishuCode]);
  const doLogin = (token, company) => {
    onLogin == null ? void 0 : onLogin(token, company);
  };
  const handleLogin = async (params) => {
    if (!loginRequest || !companyListRequest) {
      onLogin == null ? void 0 : onLogin();
      return;
    }
    let task = loginRequest(params);
    const { data: userInfoData } = await runTask(task);
    setUserInfo(userInfoData);
    task = companyListRequest(userInfoData.token);
    const { data: companyListData } = await runTask(task);
    if (companyListData.length === 1) {
      doLogin(userInfoData.token, companyListData[0]);
    } else if (companyListData.length > 1) {
      setCompanyList(companyListData);
    }
  };
  return /* @__PURE__ */ jsx("div", { children: companyList.length > 0 ? /* @__PURE__ */ jsx(
    SelectCompany,
    {
      appName,
      backgroundImage,
      companyList,
      userInfo,
      onQuit: setCompanyList,
      renderExtraCompanyInfo,
      onSelectCompany: (company) => doLogin(userInfo.token, company),
      companyFieldNames
    }
  ) : /* @__PURE__ */ jsxs(LoginWrapper, { loading, backgroundImage, children: [
    /* @__PURE__ */ jsx("div", { className: styles.rightHeader, children: showSwitchLocale && /* @__PURE__ */ jsx(SwitchLocale, {}) }),
    /* @__PURE__ */ jsx(
      LoginPanel,
      {
        appName,
        loginTypes,
        showForgotPassword,
        onLogin: handleLogin,
        feishuParams,
        verificationRequest,
        onForgotPassword
      }
    ),
    /* @__PURE__ */ jsx("div", { className: styles.rightFooter, children: appVersion && `v${appVersion}` })
  ] }) });
};
var TiLogin_default = TiLogin;
export {
  TiLogin_default as default
};
